import React from "react";
import { EditorBlock } from "draft-js";

import styles from "./Axiom.css";

export default function Axiom(props) {
  const axiom = props.block.getData().get("axiom");

  return (
    <div>
      <div className={styles.axiom} contentEditable={false}>
        {axiom}:{" "}
      </div>
      <div className={styles.text}>
        <EditorBlock {...props} />
      </div>
    </div>
  );
}
